// Same as Lincoln's InvoiceSummaryView._pct_variance (and LimeIQ's
// invoice_proxy_views._pct_variance, which works out the Draft table's
// filtered summary cards server-side): the Generate Invoices cards'
// per-currency variance.
export const pctVariance = (current, previous) => {
  if (!previous) return { pct: null, direction: null }
  const pct = Math.round(((current - previous) / previous) * 100 * 100) / 100
  return { pct, direction: pct >= 0 ? 'up' : 'down' }
}
